import { css } from 'styled-components';
import { onLightTheme } from 'students/views/shared/styled';

const STAT_INK_DARK = {
  timeSpent: '#f45ba5',
  lessons: '#a278f0',
  xp: '#accc51'
} as const;

export const myProgressTokens = css`
  --mp-surface: rgba(30, 35, 66, 0.8);
  --mp-surface-muted: rgba(30, 35, 66, 0.6);
  --mp-surface-dim: rgba(30, 35, 66, 0.3);
  --mp-surface-solid: #1e2342;
  --mp-surface-deep: #020b2a;
  --mp-surface-deep-hover: #0a1340;
  --mp-surface-well: var(--mp-surface-deep);
  --mp-surface-well-hover: var(--mp-surface-deep-hover);
  --mp-hover-tint: rgba(255, 255, 255, 0.08);
  ${onLightTheme`
    --mp-surface: rgb(var(--ln-surface-raised));
    --mp-surface-muted: rgb(var(--ln-surface-muted));
    --mp-surface-dim: rgb(var(--ln-surface-muted));
    --mp-surface-solid: rgb(var(--ln-surface-sunken));
    --mp-surface-well: rgb(var(--ln-surface-sunken));
    --mp-surface-well-hover: rgb(var(--ln-overlay) / 0.1);
    --mp-hover-tint: rgb(var(--ln-overlay) / 0.06);
    --mp-row-saved: rgb(254 208 45 / 0.16);
    --mp-row-saved-hover: rgb(254 208 45 / 0.24);
    --mp-shadow-bar: var(--ln-shadow-card);
  `}

  --mp-border: rgba(255, 255, 255, 0.15);
  --mp-track: rgba(255, 255, 255, 0.1);
  --mp-track-edge: rgba(255, 255, 255, 0.34);

  --mp-text: #fbfcff;
  --mp-text-strong: var(--color-white);
  --mp-text-muted: rgba(255, 255, 255, 0.7);
  --mp-text-dim: rgba(255, 255, 255, 0.5);
  --mp-text-faint: rgba(255, 255, 255, 0.34);
  ${onLightTheme`
    --mp-border: rgb(var(--ln-overlay) / 0.12);
    --mp-track: rgb(var(--ln-overlay) / 0.08);
    --mp-track-edge: rgb(var(--ln-overlay) / 0.5);
    --mp-text: rgb(var(--ln-content));
    --mp-text-strong: rgb(var(--ln-content));
    --mp-text-muted: rgb(var(--ln-content) / 0.7);
    --mp-text-dim: rgb(var(--ln-content) / 0.62);
    --mp-text-faint: rgb(var(--ln-content) / 0.5);
  `}

  --mp-ink-note: var(--mp-text-dim);
  --mp-ink-note-strong: var(--mp-text-dim);
  --mp-ink-note-page: var(--mp-text-dim);
  --mp-ink-mark: var(--mp-text-faint);
  --mp-edge-card: var(--mp-track-edge);
  --mp-edge-page: var(--mp-track-edge);
  --mp-ink-chip: var(--mp-text-muted);
  --mp-surface-lift: var(--mp-surface-dim);
  ${onLightTheme`
    --ln-podium-rank-ink: var(--mp-text-strong);
    --mp-edge-card: rgb(var(--ln-overlay) / 0.45);
    --mp-ink-note: var(--mp-text-muted);
    --mp-ink-note-strong: var(--mp-text-strong);
    --mp-ink-note-page: rgb(var(--ln-content) / 0.7);
    --mp-ink-mark: var(--mp-text-dim);
    --mp-edge-page: rgb(var(--ln-content) / 0.7);
    --mp-ink-chip: var(--mp-text-strong);
    --mp-surface-lift: var(--mp-surface-solid);
  `}

  --mp-accent: #06b6d4;
  --mp-accent-strong: #13b6e8;
  --mp-focus-ring: var(--mp-accent);
  ${onLightTheme`
    --mp-accent: #3dcfed;
    --mp-accent-strong: #3cccff;
    --mp-focus-ring: var(--mp-accent-on-page);
  `}

  --mp-accent-on-page: #06b6d4;
  --mp-accent-strong-on-page: #13b6e8;
  ${onLightTheme`
    --mp-accent-on-page: #00718e;
    --mp-accent-strong-on-page: #006e9c;
  `}
  --mp-shadow-card: 0 4px 12px rgba(0, 0, 0, 0.3);
  ${onLightTheme`
    --mp-shadow-card: 0 4px 12px rgb(var(--ln-overlay) / 0.12);
  `}

  --mp-stat-timespent-ink: ${STAT_INK_DARK.timeSpent};
  --mp-stat-lessons-ink: ${STAT_INK_DARK.lessons};
  --mp-stat-xp-ink: ${STAT_INK_DARK.xp};
  ${onLightTheme`
    --mp-stat-timespent-ink: #b3125f;
    --mp-stat-lessons-ink: #5925bc;
    --mp-stat-xp-ink: #0a7a36;
  `}
`;

export const STAT_COLORS = {
  timeSpent: {
    color: STAT_INK_DARK.timeSpent,
    ink: 'var(--mp-stat-timespent-ink)',
    gradientFrom: '#BF176D',
    gradientTo: '#F752A4'
  },
  lessons: {
    color: STAT_INK_DARK.lessons,
    ink: 'var(--mp-stat-lessons-ink)',
    gradientFrom: '#5925BC',
    gradientTo: '#8C57F0'
  },
  xp: {
    color: STAT_INK_DARK.xp,
    ink: 'var(--mp-stat-xp-ink)',
    gradientFrom: '#0C9443',
    gradientTo: '#BBD153'
  }
} as const;
